import { MessageComponent } from './message/message.component';

export const Components = [
    MessageComponent
];
